var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48pt",
    height: "48pt",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "#000000ff"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    opacity: 1,
    d: " M 19.40 4.64 C 25.54 3.20 32.32 4.84 37.04 9.04 C 41.88 13.20 44.48 19.77 43.76 26.11 C 43.16 32.75 38.90 38.87 32.95 41.84 C 26.57 45.14 18.39 44.62 12.53 40.43 C 6.63 36.39 3.26 29.02 4.13 21.91 C 4.86 13.68 11.34 6.40 19.40 4.64 M 20.41 8.50 C 12.95 10.03 7.34 17.51 8.03 25.11 C 8.33 33.66 16.56 40.84 25.08 39.96 C 33.98 39.62 41.22 30.70 39.74 21.91 C 38.81 12.90 29.18 6.25 20.41 8.50 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    opacity: 1,
    d: " M 22.01 14.00 C 22.75 14.00 24.25 14.00 24.99 14.00 C 25.01 17.54 24.98 21.09 25.03 24.63 C 28.00 26.38 30.97 28.14 33.93 29.92 C 33.56 30.52 32.81 31.74 32.44 32.35 C 28.96 30.26 25.47 28.19 22.00 26.08 C 22.00 22.05 21.99 18.03 22.01 14.00 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorario);
export default __webpack_public_path__ + "static/media/horario.2d821723732078698fc2a96118d2689e.svg";
export { ForwardRef as ReactComponent };